import { Dropdown } from 'react-daisyui';
import { tVariablesMenuProps } from './VariablesMenu.types';

export function VariablesMenu(props: tVariablesMenuProps) {
  const { list, onHandleClick } = props;

  return (
    <Dropdown open vertical="top" className="absolute -top-2 left-2">
      <Dropdown.Menu className="w-52">
        {list.map((item) => (
          <Dropdown.Item onClick={() => onHandleClick(item.name)}>
            {`{ ${item.name} }`}
          </Dropdown.Item>
        ))}
      </Dropdown.Menu>
    </Dropdown>
  );
}
